import React,  { useState, useEffect } from "react";
import { Formik } from "formik";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { FormattedMessage, injectIntl } from "react-intl";

import { Checkbox, FormControlLabel, TextField, MenuItem } from "@material-ui/core";
import clsx from "clsx";
import * as auth from "../../store/ducks/auth.duck";
import { register,verifyOTP,getBusinessEntitiesWoS } from "../../crud/auth.crud";

import InputLabel from '@material-ui/core/InputLabel';

import Select from '@material-ui/core/Select';

import FormControl from '@material-ui/core/FormControl';

function Registration(props) {



 
  
  const { intl } = props;

  const [regForm, setRegForm] = useState('block');
  const [verForm, setVerForm] = useState('none');


  const [loading, setLoading] = useState(false);
  const [loadingButtonStyle, setLoadingButtonStyle] = useState({
    paddingRight: "2.5rem"
  });

  const [user,setUser] =useState({});

  const [statusColor, setStatusColor] = useState('alert-success');

  const enableLoading = () => {
    setLoading(true);
    setLoadingButtonStyle({ paddingRight: "3.5rem" });
  };

  const disableLoading = () => {
    setLoading(false);
    setLoadingButtonStyle({ paddingRight: "2.5rem" });
  };

  const [entities,setEntities] =useState({entities:[]});
  
  React.useEffect(() => {
        const fetchEntities = async () => {
            try {
                //setRoles({accounts: rolesData.roles, isLoading: true});
                const response = await getBusinessEntitiesWoS()
                setEntities({entities: response.data});
            } catch (e) {
                console.log(e);
                //setRoles({roles: rolesData.roles, isLoading: false});
            }
        };
        fetchEntities();
    }, []);



  return (
    <div className="kt-login__body">
      <div className="kt-login__form">
        <div className="kt-login__title">
          <h3>
            <FormattedMessage id="AUTH.REGISTER.TITLE" />
          </h3>
        </div>
        <div style={{display: regForm}}>
        <Formik
          initialValues={{
            firstName: "",
            lastName: "",
            email: "",
            mobile: "",
            address:"",
            location:"",
            businessEntity:"",
            entityName:"",
            registrationNotes:"",
            organizationRole:"",
            acceptTerms: true
            
          }}
          validate={values => {
            const errors = {};

            if (!values.email) {
              errors.email = intl.formatMessage({
                id: "AUTH.VALIDATION.REQUIRED_FIELD"
              });
            } else if (
              !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
            ) {
              errors.email = intl.formatMessage({
                id: "AUTH.VALIDATION.INVALID_FIELD"
              });
            }

            if (!values.firstName) {
              errors.firstName = intl.formatMessage({
                id: "AUTH.VALIDATION.REQUIRED_FIELD"
              });
            }

            if (!values.lastName) {
              errors.lastName = intl.formatMessage({
                id: "AUTH.VALIDATION.REQUIRED_FIELD"
              });
            }

            if (!values.mobile) {
              errors.mobile = intl.formatMessage({
                id: "AUTH.VALIDATION.REQUIRED_FIELD"
              });
            }


            if (!values.businessEntity) {
              errors.businessEntity = intl.formatMessage({
                id: "AUTH.VALIDATION.REQUIRED_FIELD"
              });
            }


            if (!values.entityName) {
              errors.entityName = intl.formatMessage({
                id: "AUTH.VALIDATION.REQUIRED_FIELD"
              });
            }

            /*      
            if (!values.address) {
              errors.address = intl.formatMessage({
                id: "AUTH.VALIDATION.REQUIRED_FIELD"
              });
            }


            if (!values.location) {
              errors.location = intl.formatMessage({
                id: "AUTH.VALIDATION.REQUIRED_FIELD"
              });
            }
            if (!values.registrationNotes) {
              errors.registrationNotes = intl.formatMessage({
                id: "AUTH.VALIDATION.REQUIRED_FIELD"
              });
            }

            if (!values.organizationRole) {
              errors.organizationRole = intl.formatMessage({
                id: "AUTH.VALIDATION.REQUIRED_FIELD"
              });
            }
            */

            if (!values.acceptTerms) {
              errors.acceptTerms = "Accept Terms";
            }

            return errors;
          }}
          onSubmit={(values, { setStatus, setSubmitting }) => {

            enableLoading();
            register(
              values.firstName,
              values.lastName,
              values.email,
              values.mobile,
              values.businessEntity,
              values.entityName,
              values.address,
              values.location,
              values.registrationNotes,
              values.organizationRole,
              "verified"
            )
              .then(resp => {
                //props.register(accessToken);
                setUser({firstName: values.firstName, lastName: values.lastName,
             email: values.email, mobile: values.mobile,
              businessEntity: values.businessEntity,entityName: values.entityName,
              address: values.address,location : values.location,
              registrationNotes: values.registrationNotes, organizationRole: values.organizationRole,isApproved:false,registrationId: resp.data,status: 'verified'});
                console.log(resp);
                disableLoading();
                setStatus(
                  intl.formatMessage({
                    id: "REG.SUCCESS.MESSAGE"
                  })
                );
                setStatusColor('alert-success');
                /*setVerForm('block');*/
                setRegForm('block');
              })
              .catch((err) => {
                console.log(err)
                disableLoading();
                setSubmitting(false);
                setStatus(
                  intl.formatMessage({
                    id: "AUTH.VALIDATION.INVALID_LOGIN"
                  })
                );
                setStatusColor('alert-danger');
              });
          }}
        >
          {({
            values,
            status,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting
          }) => (
            <form onSubmit={handleSubmit} noValidate autoComplete="off">
              {status && (
                <div role="alert" className={"alert "+statusColor}>
                  <div className="alert-text">{status}</div>
                </div>
              )}


              <div className="form-group mb-0">
                  
                  
                     <TextField
                      margin="normal"
                      labelId="businessEntity-label"
                      id="businessEntity"
                      name="businessEntity"
                      value={values.businessEntity}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className="kt-width-full"
                      label="Choose your business"
                      style={{'width':'100%'}}
                      
                      
                    select>
                      
                      {entities.entities.map((ent) => (
                          <MenuItem key={ent.businessEntity} value={ent.businessEntity}>{ent.description}</MenuItem>
                      ))}
                    </TextField>
                    
              </div>

              <div className="form-group mb-0">
                <TextField
                  margin="normal"
                  label="Your business name"
                  className="kt-width-full"
                  name="entityName"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.entityName}
                  helperText={touched.entityName && errors.entityName}
                  error={Boolean(touched.entityName && errors.entityName)}
                />
              </div>

             
              <div className="form-group mb-0">
                <TextField
                  margin="normal"
                  label="First Name"
                  className="kt-width-full"
                  name="firstName"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.firstName}
                  helperText={touched.firstName && errors.firstName}
                  error={Boolean(touched.firstName && errors.firstName)}
                />
              </div>              

              <div className="form-group mb-0">
                <TextField
                  margin="normal"
                  label="Last Name"
                  className="kt-width-full"
                  name="lastName"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.lastName}
                  helperText={touched.lastName && errors.lastName}
                  error={Boolean(touched.lastName && errors.lastName)}
                />
              </div>

              <div className="form-group mb-0">
                <TextField
                  label="Email"
                  margin="normal"
                  className="kt-width-full"
                  name="email"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.email}
                  helperText={touched.email && errors.email}
                  error={Boolean(touched.email && errors.email)}
                />
              </div>

              <div className="form-group mb-0">
                <TextField
                  margin="normal"
                  label="Mobile"
                  className="kt-width-full"
                  name="mobile"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.mobile}
                  helperText={touched.mobile && errors.mobile}
                  error={Boolean(
                    touched.mobile && errors.mobile
                  )}
                />
              </div>


              <div className="form-group mb-0">
                <FormControlLabel
                  label={
                    <>
                      I agree the{" "}
                      <Link
                        to="/terms"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Terms & Conditions
                      </Link>
                    </>
                  }
                  control={
                    <Checkbox
                      color="primary"
                      name="acceptTerms"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      checked={values.acceptTerms}
                    />
                  }
                />
              </div>

              <div className="kt-login__actions">
                <Link
                  to="/auth/forgot-password"
                  className="kt-link kt-login__link-forgot"
                >
                  <FormattedMessage id="AUTH.GENERAL.FORGOT_BUTTON" />
                </Link>

                <Link to="/auth">
                  <button type="button" className="btn btn-secondary btn-elevate kt-login__btn-secondary">
                    Back
                  </button>
                </Link>

                <button
                  disabled={isSubmitting || !values.acceptTerms}
                 type="submit"
                    className={`btn btn-primary btn-elevate kt-login__btn-primary ${clsx(
                      {
                        "kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light": loading
                      }
                    )}`}
                    style={loadingButtonStyle}
                  >
                   Register
                </button>
              </div>
            </form>
          )}
        </Formik>
        </div>

        <div style={{display: verForm}}>
        <Formik
          initialValues={{
            otp:""
            
          }}
          validate={values => {
            const errors = {};

            

            if (!values.otp) {
              errors.otp = intl.formatMessage({
                id: "AUTH.VALIDATION.REQUIRED_FIELD"
              });
            }

            
            return errors;
          }}
          onSubmit={(values, { setStatus, setSubmitting }) => {

            enableLoading();
            verifyOTP(
              values.otp,
              user
             
            )
              .then(resp => {
                
                console.log(resp);
                disableLoading();
                setStatusColor('alert-success');
                setStatus(
                  intl.formatMessage({
                    id: "REG.SUCCESS.MESSAGE"
                  })
                );
                
              })
              .catch(() => {
                disableLoading();
                setSubmitting(false);
                setStatusColor('alert-success');
                setStatus(
                  intl.formatMessage({
                    id: "AUTH.VALIDATION.INVALID_LOGIN"
                  })
                );
                
              });
          }}
        >
          {({
            values,
            status,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting
          }) => (
            <form onSubmit={handleSubmit} noValidate autoComplete="off">
              {status && (
                <div role="alert" className={"alert "+statusColor}>
                  <div className="alert-text">{status}</div>
                </div>
              )}


              

              <div className="form-group mb-0">
                <TextField
                  margin="normal"
                  label="OTP"
                  className="kt-width-full"
                  name="otp"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.otp}
                  helperText={touched.otp && errors.otp}
                  error={Boolean(touched.otp && errors.otp)}
                />
              </div>

              

              <div className="kt-login__actions">
               
                <Link to="/auth">
                  <button type="button" className="btn btn-secondary btn-elevate kt-login__btn-secondary">
                    Back
                  </button>
                </Link>

                <button
                  disabled={isSubmitting}
                 type="submit"
                    className={`btn btn-primary btn-elevate kt-login__btn-primary ${clsx(
                      {
                        "kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light": loading
                      }
                    )}`}
                    style={loadingButtonStyle}
                  >
                   Verify
                </button>
              </div>
            </form>
          )}
        </Formik>
        </div>
      </div>
    </div>
  );
}

export default injectIntl(
  connect(
    null,
    auth.actions
  )(Registration)
);
